import {
  createTheme,
  MantineThemeProvider,
  NumberInput,
  Select,
  Textarea,
  TextInput,
} from '@mantine/core';
import { DateInput } from '@mantine/dates';
import React from 'react';
import { FIELD_STYLES } from 'src/design-system/InputWithLabel';

// The dynamic form builds its fields from backend metadata, so there is no single call site to
// swap for the design system's input components. Scoping the design system's field styles to
// this subtree gives every field — including the ones the owners table renders itself — the
// same look, without restyling the inputs the merge review and client profile screens share.
const REWORKED_FIELDS = createTheme({
  components: {
    TextInput: TextInput.extend({ styles: FIELD_STYLES }),
    NumberInput: NumberInput.extend({ styles: FIELD_STYLES }),
    Select: Select.extend({ styles: FIELD_STYLES }),
    Textarea: Textarea.extend({ styles: FIELD_STYLES }),
    DateInput: DateInput.extend({ styles: FIELD_STYLES }),
  },
});

export function ReworkedFieldStyles({ children }: { children: React.ReactNode }) {
  return <MantineThemeProvider theme={REWORKED_FIELDS}>{children}</MantineThemeProvider>;
}
